import FundUnicefKrTemplate from '@/page-blocks/about-us/clear/fund/unicef-kr/FundUnicefKrTemplate';
import ReportKorea2024 from '@/page-blocks/about-us/clear/fund/unicef-kr/report.korea_2024';
import { PageProps } from 'gatsby';
import React from 'react';

const FundUnicefKr2024: React.FC<PageProps> = (props) => (
  <FundUnicefKrTemplate year={2024} {...props}>
    <ReportKorea2024 />
  </FundUnicefKrTemplate>
);

export default FundUnicefKr2024;
